// extracted by mini-css-extract-plugin
export var askAiIcon = "_py-9";
export var container = "_py-0";
export var groupSeparator = "_py-a";
export var highlight = "_py-4";
export var resultIcon = "_py-5";
export var resultItem = "_py-7";
export var resultSubtitle = "_py-3";
export var resultTitle = "_py-2";
export var resultsList = "_py-1";
export var searchGroup = "_py-6";
export var selected = "_py-8";